var _circle, _mask, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 40.75,
    stroke: "#fff",
    strokeWidth: 2.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 52.077,
    height: 33.85,
    rx: 1.75
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 52.077,
    height: 33.85,
    rx: 1.75,
    stroke: "#fff",
    strokeWidth: 5,
    mask: "url(#prefix__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.395 26.395l24.643 15.53 24.644-15.53",
    stroke: "#fff",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a889bb1d.svg";
export { ForwardRef as ReactComponent };